import {
    Breadcrumb as ChakraBreadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbProps as ChakraBreadcrumbProps,
    Button
} from "@chakra-ui/react"
import { useRef, useState } from "react";
import { CgChevronRight } from 'react-icons/cg';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from "../../contexts/AuthContext";
import { Alert } from "../Alert";

interface BreadcrumbProps extends ChakraBreadcrumbProps {
    current_page?: string;
    previous_page?: string;
    previous_page_link?: string;
}

export function Breadcrumb({ current_page, previous_page, previous_page_link = '/', ...rest }: BreadcrumbProps) {
    const [undoChangesAlertState, setUndoChangesAlertState] = useState<boolean>(false);
    const [selectedPage, setSelectedPage] = useState<string>("");
    const { editionModeState, setEditionModeState } = useAuth();
    const navigate = useNavigate();
    const ref = useRef();
    function handleUndoChanges () {
        if (selectedPage === current_page) return;
        setUndoChangesAlertState(!undoChangesAlertState);
        setEditionModeState(!editionModeState);
        navigate(selectedPage);
    }
    return (
        <>
            <Alert
                isOpen={undoChangesAlertState}
                onClose={() => setUndoChangesAlertState(!undoChangesAlertState)}
                title="Tem certeza que deseja descartar as mudanças?"
                messageBody="As alterações que você fez agora serão perdidas."
                confirmButtonText="Descartar mudanças"
                closeButtonText="Cancelar"
                onConfirm={handleUndoChanges}
                leastDestructiveRef={ref}
            />
            <ChakraBreadcrumb  {...rest} spacing={["2", "4"]} separator={<CgChevronRight color="gray.700" />}>
                {editionModeState ? (
                    <BreadcrumbItem isCurrentPage>
                        <Button
                            h="21px"
                            p="0"
                            m="0"
                            variant="ghost"
                            fontSize={["10px", "12px", "14px"]}
                            fontWeight="400"
                            color="gray.700"
                            _hover={{ textDecor: "underline" }}
                            onClick={() => {
                                setSelectedPage("/")
                                setUndoChangesAlertState(!undoChangesAlertState)
                            }}
                        >
                            Sellers
                            
                        </Button>
                    </BreadcrumbItem>

                ) : (
                    <BreadcrumbItem>
                        <BreadcrumbLink as={Link} to="/" fontSize={["10px", "12px", "14px"]} color="gray.700">Sellers</BreadcrumbLink>
                    </BreadcrumbItem>
                )}
                {previous_page && (
                    editionModeState ? (
                        <BreadcrumbItem isCurrentPage>
                            <Button
                                h="21px"
                                p="0"
                                m="0"
                                variant="ghost"
                                fontSize={["10px", "12px", "14px"]}
                                fontWeight="400"
                                color="gray.700"
                                _hover={{ textDecor: "underline" }}
                                onClick={() => {
                                        setSelectedPage(previous_page_link)
                                        setUndoChangesAlertState(!undoChangesAlertState)
                                }}
                            >
                                {current_page}
                            </Button>
                        </BreadcrumbItem>
                    ) : (
                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink as={Link} to={previous_page_link} fontSize={["10px", "12px", "14px"]} color="gray.700">{previous_page}</BreadcrumbLink>
                        </BreadcrumbItem>
                    )
                )}
                <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink fontSize={["10px", "12px", "14px"]} color="gray.700">{current_page}</BreadcrumbLink>
                </BreadcrumbItem>
            </ChakraBreadcrumb>
        </>
    )
}